import Image from 'next/image';
import IconDarkCharcoal from './help_dark_charcoal.svg?url';
import IconWhite from './help_dark_charcoal.svg?url';
import type { SvgImageProps } from '../types';

export const HelpDarkCharcoalImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={IconDarkCharcoal} alt={alt} {...props} />;

export const HelpWhiteImage: React.FC<SvgImageProps> = ({ alt, ...props }) => (
  <Image src={IconWhite} alt={alt} {...props} />
);
